import apiClient from './client';

export const authAPI = {
  register: (data) => apiClient.post('/auth/register', data),
  registerByType: (data) => apiClient.post('/auth/register-by-type', data),
  login: (data) => apiClient.post('/auth/login', data),
  getMe: () => apiClient.get('/auth/me'),
  updateMe: (data) => apiClient.put('/auth/me', data),
  changePassword: (data) => apiClient.put('/auth/change-password', data),
  logout: () => apiClient.post('/auth/logout'),
  refreshToken: (refreshToken) => apiClient.post('/auth/refresh', { refreshToken }),
  sendPasswordResetOtp: (email) => apiClient.post('/auth/forgot-password/send-otp', { email }),
  verifyPasswordResetOtp: (email, otp) => apiClient.post('/auth/forgot-password/verify-otp', { email, otp }),
  resetPassword: (email, otp, newPassword) => apiClient.post('/auth/forgot-password/reset', { email, otp, new_password: newPassword }),
};
